import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Meta from '../common/Meta';
import AdminBlogRequestTable from './AdminBlogRequestTable';
import RequestUtil from '../../utils/APIRequestUtil';
import AdminMenu from './AdminMenu';

const getMeta = (name, description) => {
    return {
        title: `博客「${name}」审核详情 - 博客中心 · 博客世界的中心点！`,
        keywords: name,
        description: description
    }
}

export default function AdminBlogRequest() {
    const [blogRequest, setBlogRequest] = useState({ 'posts': [] });

    const { id } = useParams();

    const fetchData = async (id) => {
        const resp = await RequestUtil.get(`/api/blog-requests/${id}`);

        const respBody = await resp.json();

        setBlogRequest(respBody);
    };

    useEffect(() => {
        fetchData(id);
    }, [id]);

    return (
        <>
            <Meta meta={getMeta(blogRequest.name, blogRequest.description)} />
            <header className="redesign-page-header">
                <h1 className="redesign-page-title">
                    {blogRequest.name ? `博客「${blogRequest.name}」审核详情` : '审核详情'}
                </h1>
                <p className="redesign-page-desc">管理后台 — 审核并处理博客收录申请。</p>
            </header>
            <AdminMenu />
            <AdminBlogRequestTable blogRequest={blogRequest} />
        </>
    )
}